import { useThemeStore } from '@/stores';

/** 是否按浅色绘制（显式浅色，或自动且当前解析为浅色） */
export function useIsLightUi(): boolean {
  return useThemeStore(
    (s) =>
      s.themePreference === 'light' ||
      (s.themePreference === 'system' && s.resolvedTheme === 'light')
  );
}
